import TiktokEmbed from './TiktokEmbed';

export { TiktokEmbed };
